export default __webpack_public_path__ + "64fe76c344a69e76e8746b473e6bd480.png";